var _circle, _circle2, _circle3, _ellipse, _circle4, _circle5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBg1280V1 = function SvgBg1280V1(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 900,
    viewBox: "0 0 1280 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1259,
    cy: 751,
    r: 345,
    fill: "#36A9E0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 914,
    cy: 755,
    r: 118,
    fill: "#008FF5"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 83,
    cy: -92,
    r: 381,
    fill: "#9B51E0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1297.5,
    cy: 89,
    rx: 233.5,
    ry: 234,
    fill: "#FE5F42"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1058.5,
    cy: -49.5,
    r: 145.5,
    fill: "#F9B233"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: -26,
    cy: 310,
    r: 148,
    fill: "#4D4D4D"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBg1280V1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bg_1280_v1.92524f77fecda9ad5785e8939b56f220.svg";